import { multipartRequest } from "../../api/API"

export const sendNotification = (data) => {
    return multipartRequest.post('/custom_panel/sendNotifications/', data);
}